import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFolder} from "@fortawesome/free-solid-svg-icons";
import {FilesContent} from "../../../files/FilesContent";

export class Files implements StoryTool {
    id = 'files-manager'
    name = "File Manager"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`,
    ]
    enabled = true
    icon = <FontAwesomeIcon icon={faFolder}/>
    entryPoint = <FilesContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}